var cashflowTemplateState = {
    searchFilter: {
        page: 1,
        pageSize: 10,
        name: ''
    }
};
export default cashflowTemplateState;
